import React from 'react';
import { useAuth } from '../context/AuthContext';
import SubscriptionPaymentPanel from './SubscriptionPaymentPanel';
import { AlertCircle } from 'lucide-react';

export default function SubscriptionPaymentBanner() {
  const { user, checkAuth } = useAuth();
  const sub = user?.subscription;

  if (!sub || sub.access_blocked) return null;
  if (sub.phase !== 'active') return null;
  if (!sub.payment_due_soon && !sub.pending_transfer) return null;

  return (
    <div
      className="mb-6 rounded-md border border-amber-300 bg-amber-50 px-4 py-3"
      data-testid="subscription-payment-banner"
    >
      <div className="flex items-start gap-2 text-xs text-amber-900 mb-3">
        <AlertCircle size={14} className="shrink-0 mt-0.5" />
        <span>
          {sub.pending_transfer
            ? 'Tu transferencia está en revisión.'
            : `Tu suscripción vence en ${sub.renewal_days_remaining ?? 0} día(s). Realiza el pago para evitar la suspensión del panel.`}
        </span>
      </div>
      {!sub.pending_transfer && (
        <SubscriptionPaymentPanel subscription={sub} onUpdated={checkAuth} compact />
      )}
    </div>
  );
}
